module.exports = __webpack_public_path__ + "img/list_2.0c003d85.png";